import { Menu, Icon } from 'antd';
import { ClickParam } from 'antd/lib/menu';
import classNames from 'classnames';
import React from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

import 'antd/dist/antd.css';
import '../custom-antd.css';

import { ISidebarMenu, ISubMenuLinks } from '../Sidebar';

import useStyles from '../styles';
import { useSideBarOpened } from '../../../hooks/context/useSideBarOpened.hook';

const { SubMenu } = Menu;

interface ISidebarLink {
  menuData: (ISidebarMenu | undefined)[]
}

const SidebarLink: React.FC<ISidebarLink> = ({ menuData }) => {
  const location = useLocation();
  const classes = useStyles();
  const [isSidebarOpened] = useSideBarOpened();
  const getActiveMenuLink = menuData
    .find(menu => menu?.link === location.pathname)?.link;
  const subMenuLinks: ISubMenuLinks[] = [];

  menuData.forEach(menu => {
    if (menu?.subMenu) {
      menu.subMenu.forEach(submenu => subMenuLinks.push({ ...submenu, categoryId: menu.id }));
    }
  });

  const getActiveSubMenuLink = subMenuLinks.find(menu => menu.link === location.pathname);

  const getActiveLink = getActiveMenuLink || getActiveSubMenuLink?.link || '/dashboard';

  const history = useHistory();

  const handleMenuClick = (menu: ClickParam) => {
    return history.push(menu.key);
  };

  return (
    <Menu
      defaultSelectedKeys={[getActiveLink]}
      inlineCollapsed={!isSidebarOpened}
      mode="inline"
      className={classNames(classes.menu, {
        [classes.menuOpen]: isSidebarOpened,
        [classes.menuClose]: !isSidebarOpened,
      })}
      onClick={handleMenuClick}
      defaultOpenKeys={getActiveSubMenuLink?.categoryId ? [`${getActiveSubMenuLink?.categoryId}`] : undefined}
    >
      {menuData.map(menu => (menu?.subMenu ? (
        <SubMenu
          key={menu.id}
          title={(
            <span style={{ display: 'flex' }}>
              <Icon type={menu.icon} className={classes.linkIcon} />
              <span>{menu.label}</span>
            </span>
          )}
        >
          {menu.subMenu.map(subMenu => (
            <Menu.Item key={subMenu.link}>
              <span>{subMenu.label}</span>
            </Menu.Item>
          ))}
        </SubMenu>
      ) : (
        <Menu.Item key={menu?.link}>
          <Icon type={menu?.icon} className={classes.linkIcon} />
          <span>
            {menu?.label}
          </span>
        </Menu.Item>
      )))}
    </Menu>
  );
};

export default SidebarLink;
